import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import OurStory from "@/pages/OurStory";

export const Route = createFileRoute("/en/about-qbd/story")({
  head: () => buildRouteHead("/en/about-qbd/story"),
  component: OurStory,
});

